import { useEffect } from 'react';
import { getIframeUrl } from '@adsk/issues-ui/es/app/selectors';
import { connect } from '@adsk/issues-ui/es/app/connect';
import PropTypes from 'prop-types';

const IssueCreateNewEntityWrapper = props => {
  const { children, docIframeOpen } = props;
  useEffect(() => {
    if (docIframeOpen) {
      const createModalBackdrop = document.querySelector(
        '.issues-entity-create-modal.SimpleModal-backdrop'
      );
      const createModal = document.querySelector('.issues-entity-create-modal.SimpleModal');
      const entityLinkerModal = document.querySelector('.EntityPickerModal.SimpleModal-dialog');
      if (createModalBackdrop && createModal) {
        createModalBackdrop.style.display = 'none';
        createModal.style.display = 'none';
        entityLinkerModal.style.transform = 'none';
      }
    }
    return () => {
      if (docIframeOpen) {
        const createModalBackdrop = document.querySelector(
          '.issues-entity-create-modal.SimpleModal-backdrop'
        );
        const createModal = document.querySelector('.issues-entity-create-modal.SimpleModal');
        const entityLinkerModal = document.querySelector('.EntityPickerModal.SimpleModal-dialog');
        if (createModalBackdrop && createModal) {
          createModalBackdrop.style.display = 'block';
          createModal.style.display = 'block';
          entityLinkerModal.style.transform = 'translate(0, 0)';
        }
      }
    };
  }, [docIframeOpen]);
  return children;
};

IssueCreateNewEntityWrapper.displayName = 'IssueCreateNewEntityWrapper';
IssueCreateNewEntityWrapper.displayName = {
  children: PropTypes.node.isRequired,
  docIframeOpen: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
  return { docIframeOpen: !!getIframeUrl(state) };
};
export default connect(mapStateToProps)(IssueCreateNewEntityWrapper);
